exports.isDisabled = (array) => {

    if (!array || !array.length) {
        return true
    }

    const temp = array.find(item => !item.disabled) ? false : true
    console.log(temp)
    return temp
}